import React from "react";
import ImageItem from "../../../../../../components/ImageItem";
import { getImageUrl } from "../../../../../../utils";
import { HeaderAction, HeaderComponent } from "../../../types";
import { renderIcon } from "../../../utils/icons";
import VisibilitySettings from "./VisibilitySettings";

interface LogoSettingsProps {
	component: HeaderComponent;
	dispatch: React.Dispatch<HeaderAction>;
	onBackClick: () => void;
}

const LogoSettings: React.FC<LogoSettingsProps> = ({
	component,
	dispatch,
	onBackClick,
}) => {
	return (
		<div className="p-4">
			<div className="flex items-center mb-4">
				<button
					className="mr-2 p-1 rounded hover:bg-gray-100"
					onClick={onBackClick}>
					{renderIcon("menu", 16)}
				</button>
				<h3 className="text-lg font-medium">Logo Settings</h3>
			</div>

			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">Size</label>
				<select
					className="w-full p-2 border rounded"
					value={component.settings?.size || "M"}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										size: e.target.value,
									},
								},
							},
						})
					}>
					<option value="XS">XS</option>
					<option value="S">S</option>
					<option value="M">M</option>
					<option value="L">L</option>
					<option value="XL">XL</option>
				</select>
			</div>

			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Image URL
				</label>
				<ImageItem
					image={{
						image: component.settings?.image,
						title: component.settings?.title,
						description: component.settings?.description,
						link: component.settings?.link,
					}}
					setImages={() => {}}
					setImage={(image: any) => {
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										image: getImageUrl(image?.image),
									},
								},
							},
						});
					}}
					onlyImage={true}
				/>
				<input
					type="text"
					className="w-full p-2 border rounded"
					value={component.settings?.image}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										image: e.target.value,
									},
								},
							},
						})
					}
				/>
			</div>

			<div className="mb-4">
				<label className="block text-sm font-medium mb-1">
					Link URL
				</label>
				<input
					type="text"
					className="w-full p-2 border rounded"
					value={component.settings?.link}
					onChange={(e) =>
						dispatch({
							type: "UPDATE_COMPONENT",
							payload: {
								id: component.id,
								updates: {
									settings: {
										...component.settings,
										link: e.target.value,
									},
								},
							},
						})
					}
				/>
			</div>

			<VisibilitySettings component={component} dispatch={dispatch} />
		</div>
	);
};

export default LogoSettings;
